<div class="py-24 sm:py-32">
    <div class="max-w-3xl mx-auto px-6 py-8 font-sans text-gray-800 leading-relaxed" @fadeIn>
        <h1 class="text-4xl font-bold text-gray-900 mb-4">{{ 'license.title' | translate }}</h1>
        <p class="text-sm text-gray-600 italic mb-8">{{ 'license.last_updated' | translate:{ date: currentDate | date:'longDate' } }}</p>

        <div @staggerSections>
            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[0].number }}. {{ ('license.content.sections' | translate)[0].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.grant' | translate }}
                </p>
            </section>

            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[1].number }}. {{ ('license.content.sections' | translate)[1].title }}</h2>
                <p class="mb-4">{{ 'license.content.scope.description' | translate }}</p>
                <ul class="list-disc pl-6 space-y-2" @listAnimation>
                    <li *ngFor="let right of ('license.content.scope.rights' | translate)">{{ right }}</li>
                </ul>
            </section>

            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[2].number }}. {{ ('license.content.sections' | translate)[2].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.restrictions' | translate }}
                </p>
            </section>

            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[3].number }}. {{ ('license.content.sections' | translate)[3].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.ownership' | translate }}
                </p>
            </section>

            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[4].number }}. {{ ('license.content.sections' | translate)[4].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.updates' | translate }}
                </p>
            </section>

            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[5].number }}. {{ ('license.content.sections' | translate)[5].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.disclaimer' | translate }}
                </p>
            </section>

            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[6].number }}. {{ ('license.content.sections' | translate)[6].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.liability' | translate }}
                </p>
            </section>

            <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[7].number }}. {{ ('license.content.sections' | translate)[7].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.termination' | translate }}
                </p>
            </section>

            <section class="mb-8 pb-8">
                <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('license.content.sections' | translate)[8].number }}. {{ ('license.content.sections' | translate)[8].title }}</h2>
                <p class="mb-4">
                    {{ 'license.content.contact.description' | translate }}
                </p>
                <p class="text-gray-700">{{ 'license.content.contact.info' | translate }}</p>
            </section>
        </div>
    </div>
</div>
